/**
 * 只用于商品详情页的错误弹窗提示
 */

import { use18n, useIns } from 'src/utils/v2_helper/common'
import IndexDialog from 'src/components/dialog/index.vue'
import { dialogQueue } from 'src/components/dialog';
import { clearCartTableId, getTable, setTable } from 'src/utils/common';
import { PRODUCT_DETAIL_INVALID, RECOMMEND_PRODUCT_INVALID } from 'src/utils/config';

const INVALID_CODE = [302, 304, 726, 727, 302, 314, 316, 317, 315, 303].reduce((p, it) => ({ ...p, [it]: true }), {});
function backToList(vm) {
  vm.$router.replace({ name: 'products-list' });
}
function onBack(vm) {
  console.log('onBack: ', vm.$route.name)
  if (vm.$route.name === 'product-detail') {
    vm.$router.back();
  }
}
function getConf(code, { table, product }, vm) {
  const _table = table || getTable();
  const CONFIG = {
    517: {
      customIcon: 'http://static.bakmigm.co.id/menu/full_dine_change_table_icon_2023_02_17.png',
      title: vm.$t('fullDinein.tableChangedOriginTitle', { _table }),
      ok: 'OK',
      onOk() {
        if (table) setTable(table);
        clearCartTableId();
        setTimeout(window.location.reload, 500);
      }
    },
    726: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        onBack(vm)
      }
    },
    727: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        onBack(vm)
      }
    },
    302: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        onBack(vm);
      },
    },
    303: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        onBack(vm);
      },
    },
    309: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        setTimeout(window.location.reload, 500);
      }
    },
    307: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        setTimeout(window.location.reload, 500);
      }
    },
    315: {
      title: vm.$t('details.invalidTip'),
      ok: 'OK',
      onOk() {
        onBack(vm);
      }
    },
    // 价格变化返回的出code，需要刷新，走默认
    // 321: {}
  }
  const defaultConf = {
    title: vm.$t('details.invalidTip'),
    ok: 'OK',
    onOk() {
      setTimeout(() => window.location.reload(), 500);
    }
  }
  return CONFIG[code] || defaultConf;
}
export function useErrorDialog() {
  const app = useIns();
  function show(code, data) {
    const conf = getConf(code, data, app);
    if (!conf) {
      return console.warn(`>>useErrorDialog[PATH: ${app.$route.name}]\n [CODE: ${code}] error config is empty!`);
    }
    const dialog = app.$q.dialog({
      component: IndexDialog,
      parent: app,
      title: conf.title,
      describe: conf.describe,
      ok: conf.ok,
      cancel: conf.cancel,
      customIcon: conf.customIcon,
      type: conf.type,
    }).onOk(conf.onOk).onCancel(conf.onCancel);
    if (INVALID_CODE[code]) {
      // 在商品失效的code中，如果为303表示无库存，不如要直接将商品从列表中移除，其他都需要将商品移除
      const inStock = !(code === 303);
      if (data?.product) {
        app.$bus.$emit(RECOMMEND_PRODUCT_INVALID);
        app.$bus.$emit(PRODUCT_DETAIL_INVALID, {
          ...data.product,
          inStock,
          inLive: !inStock,
          inList: !inStock,
          inService: !inStock,
          inSingleSale: !inStock
        })
      }
    }
    dialogQueue.push(dialog);
    return dialog;
  }

  return { show }
}
